import type { FC, LabelHTMLAttributes, ReactNode } from 'react';
import { cx } from '@/styled-system/css';
import { label, labelDisabled } from './label.styles';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
}

const Label: FC<LabelProps> = ({ children, className, disabled, ...rest }) => {
  return (
    <label {...rest} className={cx(label, disabled && labelDisabled, className)}>
      {children}
    </label>
  );
};

export default Label;
